export const normalizePhoneNumber = (input) => {
  const digits = input.replace(/\D/g, ''); // Remove non-digit characters
  const formattedNumber = digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  return formattedNumber;
};
